import { Formik, Form, Field } from 'formik';
import Link from 'next/link';

import { useAuthentication } from 'hooks';

import { RegisterFormInitialValues } from 'utils/constants/formsInitialValues';
import { LoginValidationSchema as validationSchema } from 'utils/functions/validationSchemas';

const RegisterForm = () => {
  const { registrationResponse, handleRegistration } = useAuthentication();

  return (
    <Formik
      initialValues={RegisterFormInitialValues}
      validationSchema={validationSchema}
      onSubmit={handleRegistration}
    >
      {({ isValid, errors, touched }) => (
        <Form className="flex flex-col mx-20">
          <div className="border-b border-gray-200 dark:border-gray-700 mb-5">
            <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400">
              <li className="me-2 flex-auto">
                <Link
                  href="/login"
                  className="w-full inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
                >
                  Sign In
                </Link>
              </li>
              <li className="me-2 flex-auto">
                <Link
                  href="/register"
                  className="w-full inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                >
                  Join Waitlist
                </Link>
              </li>
            </ul>
          </div>

          {!registrationResponse && (
            <>
              <label
                htmlFor="email"
                className="aeonik mb-5 text-xl font-aeonik-medium"
              >
                Reserve your spot
              </label>

              <div className="flex flex-col mb-6 gap-3">
                <div className="flex flex-col gap-1">
                  <label className="aeonik text-md text-gray-500">
                    Your email*
                  </label>
                  <Field
                    name="email"
                    type="email"
                    autocomplete="false"
                    placeholder="name@email.com"
                    className={`w-full border h-12 text-sm focus:outline-none mr-1 rounded-lg bg-surface text-neutrals-80 placeholder:text-neutrals-60 ${
                      errors.email
                        ? 'border-danger-40 text-danger-60'
                        : 'border-neutrals-40'
                    }`}
                  />
                </div>
                <div className="flex gap-4">
                  <div className="flex-1">
                    <label className="aeonik text-md text-gray-500">
                      First name
                    </label>
                    <Field
                      name="firstName"
                      type="text"
                      placeholder="John"
                      className={`w-full border h-12 text-sm focus:outline-none mr-1 rounded-lg bg-surface text-neutrals-80 placeholder:text-neutrals-60 ${
                        errors.firstName
                          ? 'border-danger-40 text-danger-60'
                          : 'border-neutrals-40'
                      }`}
                    />
                  </div>
                  <div className="flex-1">
                    <label className="aeonik text-md text-gray-500">
                      Last name
                    </label>
                    <Field
                      name="lastName"
                      type="text"
                      placeholder="Smith"
                      className={`w-full border h-12 text-sm focus:outline-none mr-1 rounded-lg bg-surface text-neutrals-80 placeholder:text-neutrals-60 ${
                        errors.lastName
                          ? 'border-danger-40 text-danger-60'
                          : 'border-neutrals-40'
                      }`}
                    />
                  </div>
                </div>
                {/* <div className="flex flex-col gap-1">
                  <label className="aeonik text-md text-gray-500">
                    Choose a Password *
                  </label>
                  <Field
                    name="password"
                    type="password"
                    placeholder="••••••••"
                    className={`w-full border h-12 text-sm focus:outline-none mr-1 rounded-lg bg-surface text-neutrals-80 placeholder:text-neutrals-60 ${
                      errors.password
                        ? 'border-danger-40 text-danger-60'
                        : 'border-neutrals-40'
                    }`}
                  />
                </div> */}
              </div>
              <button
                type="submit"
                disabled={!isValid || Object.keys(touched).length === 0}
                className={`border h-12 text-sm focus:outline-none mr-1 rounded-full ${
                  isValid && Object.keys(touched).length > 0
                    ? 'bg-primary-60 text-white'
                    : 'bg-neutrals-40 text-neutrals-100'
                }`}
              >
                JOIN WAITLIST
              </button>

              <span className="mt-2 text-sm">
                We&apos;re so excited to have you join as a founding member.
                We&apos;ll keep you updated as we roll out the Endless platform
                to our community.
              </span>
            </>
          )}

          {registrationResponse && (
            <>
              <label
                htmlFor="email"
                className="aeonik mb-5 text-xl font-aeonik-medium"
              >
                🎉 Information submitted successfully
              </label>
            </>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default RegisterForm;
